import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    // 登录逻辑，暂时直接跳转
    if (username && password) {
      navigate('/admin');
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center overflow-hidden">
      {/* 背景图片 */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/d1947eb5fb426d9c5f24d5fdb317a315.jpg"
          alt="登录背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-black/70 to-teal-900/50"></div>
      </div>

      {/* 返回首页按钮 */}
      <button 
        onClick={() => navigate('/')}
        className="absolute top-8 left-8 z-20 flex items-center gap-2 text-white/70 hover:text-white transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-line text-xl"></i>
        <span className="text-sm font-medium">返回首页</span>
      </button>

      {/* 登录卡片 */}
      <div className="relative z-10 w-full max-w-md mx-4">
        <div className="bg-gray-900/80 backdrop-blur-xl rounded-2xl shadow-2xl border border-teal-500/20 p-8">
          {/* Logo和标题 */}
          <div className="text-center mb-8">
            <div className="flex justify-center mb-4">
              <img 
                src="https://static.readdy.ai/image/a68e6275e3edc3dffa3b1dce13502b4a/e4c5d2d87fb7ab856d386f6e17f08b6c.png" 
                alt="Logo" 
                className="h-16 w-16"
              />
            </div>
            <h1 className="text-3xl font-bold text-white mb-2">智创灵眸</h1>
            <p className="text-sm text-teal-400">SMART PORT UAV PLATFORM</p>
          </div>

          {/* 登录表单 */}
          <form onSubmit={handleLogin} className="space-y-6">
            {/* 用户名输入 */}
            <div>
              <label className="block text-sm font-medium text-white/90 mb-2">
                用户名
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <i className="ri-user-line text-teal-400 text-lg"></i>
                </div>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-full pl-12 pr-4 py-3 bg-gray-800/50 border border-teal-500/30 rounded-lg text-white text-sm placeholder-gray-500 focus:outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20 transition-all"
                  placeholder="请输入用户名"
                  required
                />
              </div>
            </div>

            {/* 密码输入 */}
            <div>
              <label className="block text-sm font-medium text-white/90 mb-2">
                密码
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <i className="ri-lock-line text-teal-400 text-lg"></i>
                </div>
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-12 pr-12 py-3 bg-gray-800/50 border border-teal-500/30 rounded-lg text-white text-sm placeholder-gray-500 focus:outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20 transition-all"
                  placeholder="请输入密码"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-0 pr-4 flex items-center cursor-pointer"
                >
                  <i className={`${showPassword ? 'ri-eye-line' : 'ri-eye-off-line'} text-gray-400 hover:text-teal-400 text-lg transition-colors`}></i>
                </button>
              </div>
            </div>

            {/* 记住密码和忘记密码 */}
            <div className="flex items-center justify-between text-sm">
              <label className="flex items-center gap-2 cursor-pointer">
                <input 
                  type="checkbox" 
                  className="w-4 h-4 rounded border-teal-500/30 bg-gray-800/50 text-teal-500 focus:ring-2 focus:ring-teal-500/20 cursor-pointer"
                />
                <span className="text-white/70">记住密码</span>
              </label>
              <a href="#" className="text-teal-400 hover:text-teal-300 transition-colors">
                忘记密码?
              </a>
            </div>

            {/* 登录按钮 */}
            <button
              type="submit"
              className="w-full py-3 bg-gradient-to-r from-teal-500 to-teal-600 text-white font-medium rounded-lg hover:from-teal-600 hover:to-teal-700 transition-all hover:shadow-lg hover:shadow-teal-500/30 flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
            >
              <span>登录平台</span>
              <i className="ri-arrow-right-line"></i>
            </button>
          </form>

          {/* 分割线 */}
          <div className="relative my-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-700"></div>
            </div>
            <div className="relative flex justify-center text-xs">
              <span className="px-4 bg-gray-900/80 text-gray-500">其他登录方式</span>
            </div>
          </div>

          {/* 第三方登录 */}
          <div className="flex justify-center gap-4">
            <button className="w-12 h-12 flex items-center justify-center rounded-lg bg-gray-800/50 border border-teal-500/20 hover:border-teal-500/50 hover:bg-gray-800 transition-all cursor-pointer">
              <i className="ri-wechat-fill text-xl text-green-500"></i>
            </button>
            <button className="w-12 h-12 flex items-center justify-center rounded-lg bg-gray-800/50 border border-teal-500/20 hover:border-teal-500/50 hover:bg-gray-800 transition-all cursor-pointer">
              <i className="ri-qq-fill text-xl text-blue-400"></i>
            </button>
            <button className="w-12 h-12 flex items-center justify-center rounded-lg bg-gray-800/50 border border-teal-500/20 hover:border-teal-500/50 hover:bg-gray-800 transition-all cursor-pointer">
              <i className="ri-phone-fill text-xl text-teal-400"></i>
            </button>
          </div>
        </div>

        {/* 底部提示 */}
        <p className="text-center text-sm text-white/50 mt-6">
          登录即表示您同意我们的
          <a href="#" className="text-teal-400 hover:text-teal-300 transition-colors mx-1">服务条款</a>
          和
          <a href="#" className="text-teal-400 hover:text-teal-300 transition-colors ml-1">隐私政策</a>
        </p>
      </div>
    </div>
  );
}